import { JobRoleTypes } from "./jobroletypes.component";
import { JobRoleType } from "./jobroletype.component";
import { EditJobRoleType } from "./jobroletype.edit.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { editJobRoleTypeState, jobRoleTypesState, jobRoleTypeState, newJobRoleTypeState } from "./jobroletypes.states";
import { AllMaterialModule } from "../../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";

import SharedModule from "../../shared/shared.module";
import { CoreModule } from "../../core/core.module";

let JOB_ROLE_TYPE_STATES = [editJobRoleTypeState, jobRoleTypesState, jobRoleTypeState, newJobRoleTypeState];

import { ConfirmDialog } from "../../shared/confirm-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        SharedModule,
        CoreModule,
        FlexLayoutModule,
        UIRouterModule.forChild({ states: JOB_ROLE_TYPE_STATES })
    ],
    declarations: [JobRoleTypes, JobRoleType, EditJobRoleType],
    entryComponents: [ConfirmDialog]
})
export default class JobRoleTypesModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobroletypes/jobroletypes.module.ts